import CTA_SMALL from "@assets/quick-news/cta-small.svg";
import ChevronImage from "@assets/video_widget/Chevron.webp";
import ArticleCard from "@blocks/Card/ArticleCard";
import QuickNewsArticleCard from "@blocks/Card/QuickNewsArticleCard";
import Heading from "@elements/Typography/Heading";
import { QN_ENTRY_RECENT } from "@helper/getEnvVariables";
import type { ProcessedArticleData } from "@helper/transformer/useOsResponse";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

export const RecentArticlesSection = ({
  recentArticles,
}: {
  recentArticles: ProcessedArticleData[];
}) => {
  const isQuickNews = QN_ENTRY_RECENT === "1";
  const source = "recent_article";
  const recentOverrideStyle = isQuickNews
    ? {
        cardWrapper:
          "w-full max-lg:max-w-[350px] flex flex-col gap-2.5 rounded-[40px] overflow-hidden mx-auto my-5 py-0 lg:pb-2.5 bg-white-100 shadow-[0_4px_4px_0_rgba(0,0,0,0.25)]",
        paragraphStyle: "lg:text-2sm",
        titleStyle:
          "font-semibold font-primary text-sm2 text-gray-100 hover:text-gray-100",
        imageWrapperStyle: "w-full lg:w-[350px] h-55 lg:h-64",
        titleWrapper: "max-w-[350px]",
        imageStyle: "w-full min-w-[350px] h-55 lg:h-64 sm:h-100",
        contentWrapper: "px-2.5 py-2 lg:pt-0 bg-white-100",
      }
    : {
        cardWrapper: "w-full lg:w-fit flex flex-col lg:border-b-0",
        paragraphStyle: "lg:text-2sm",
        titleStyle:
          "font-semibold font-primary text-sm2 text-gray-100 hover:text-gray-100",
        imageWrapperStyle:
          "w-full max-w-full lg:w-84 h-55 lg:h-64 lg:max-h-64 sm:h-100 sm:w-full",
        titleWrapper: "gap-0",
        imageStyle: "h-55 lg:h-64 sm:h-100",
        contentWrapper: "",
      };
  const heroArticle = recentArticles.at(0);
  const sideArticles = recentArticles.slice(1);

  const sideCardElements = {
    hasParagraph: false,
    hasDate: false,
    hasDateInAgo: true,
    hasQuickNews: isQuickNews,
  };
  return (
    <div
      className={twMerge(
        "border-b border-pink-300",
        isQuickNews && "bg-gray-500 px-5",
      )}
    >
      <Heading
        Element="h2"
        className={twMerge(
          "text-red-100 text-2.5md font-bold mt-5 hover:underline hover:cursor-pointer hover:text-red-200",
          isQuickNews && "text-sm py-2.5",
        )}
      >
        <Link
          reloadDocument
          to={isQuickNews ? "/quick-news?ref=" + source : "/recent-articles"}
          target="_blank"
          rel="noopener noreferrer"
        >
          {isQuickNews && (
            <img
              alt="toggle-button-chevie"
              height={40}
              width={40}
              className="pr-100 inline"
              src={CTA_SMALL}
            />
          )}
          அண்மைய செய்திகள்
          <img
            alt="toggle-button-chevie"
            height={26}
            width={26}
            className="pl-100 inline"
            src={ChevronImage}
          />
        </Link>
      </Heading>
      <div className="flex flex-col lg:flex-row pb-5">
        {heroArticle &&
          (isQuickNews ? (
            <QuickNewsArticleCard
              key={heroArticle.id}
              displayWidth={350}
              displayHeight={260}
              {...heroArticle}
              overrideStyle={recentOverrideStyle}
              refMedium={source}
            />
          ) : (
            <ArticleCard
              key={heroArticle.id}
              displayWidth={390}
              displayHeight={260}
              elements={{
                hasParagraph: false,
                hasDate: false,
                hasDateInAgo: true,
              }}
              {...heroArticle}
              overrideStyle={recentOverrideStyle}
              refMedium={source}
            />
          ))}

        <div className="flex-col lg:pl-lg lg:pr-0.5">
          {sideArticles.map((article, i) => (
            <ArticleCard
              key={article.id}
              displayWidth={135}
              displayHeight={90}
              elements={sideCardElements}
              {...article}
              overrideStyle={{
                cardWrapper:
                  i + 1 === sideArticles.length
                    ? "w-full lg:w-full flex-row-reverse border-b-0"
                    : i === 0
                      ? "w-full lg:w-full flex-row-reverse pb-5"
                      : "w-full lg:w-full flex-row-reverse py-5",
                paragraphStyle: "lg:text-2sm",
                titleStyle:
                  "font-semibold font-primary text-sm2 text-gray-100 hover:text-gray-100",
                imageWrapperStyle: "w-31.5 max-w-40 lg:w-31.5 h-23 sm:w-full",
                titleWrapper: "gap-0",
                imageStyle: "w-full h-23",
                contentWrapper: i === 0 ? "" : "gap-2.5",
              }}
              refMedium={source}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
